/*
  Remembers the filtered listing a visitor came from, and offers a way
  straight back to it from a product page.

  Shopify has no /collections/x/tag/products/y URL, so a tag filter cannot
  travel into a product URL. Without this, someone who filtered to New
  York, opened Shinnecock Hills and pressed Back landed on the unfiltered
  collection and lost their place.

  sessionStorage rather than a query parameter: the product URL stays clean
  and shareable, and the memory dies with the tab, which is the right
  lifetime for "where I just was".

  The link is server rendered with a working destination, so this only
  ever upgrades it to somewhere more specific. Nothing to hide or show.

  Markup contract:
    <ironwood-return-to-results>
      <a data-return-link href="/collections/x">Back</a>
    </ironwood-return-to-results>

  On a collection page the element is absent; the script records the
  current view instead.
*/

const KEY = 'ironwood:return-to-results';

function remember(collectionUrl) {
  // Only worth remembering a narrowed view. The plain collection is
  // already where the breadcrumb goes.
  const path = window.location.pathname;
  const isFiltered = path.startsWith(collectionUrl) && path !== collectionUrl;

  try {
    if (!isFiltered) {
      sessionStorage.removeItem(KEY);
      return;
    }
    sessionStorage.setItem(KEY, JSON.stringify({ url: path + window.location.search }));
  } catch {
    // Private browsing and blocked storage are fine; the link still works.
  }
}

function offerReturn(element) {
  let saved;
  try {
    saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  } catch {
    return;
  }
  if (!saved?.url) return;

  const link = element.querySelector('[data-return-link]');
  if (link) link.href = saved.url;
}

class IronwoodReturnToResults extends HTMLElement {
  connectedCallback() {
    offerReturn(this);
  }
}

if (!customElements.get('ironwood-return-to-results')) {
  customElements.define('ironwood-return-to-results', IronwoodReturnToResults);
}

// On a collection page there is no element, only a view worth recording.
const finder = document.querySelector('ironwood-course-finder');
if (finder) remember(finder.dataset.collectionUrl || '');
